import { MarketLeftNavsList, TenderDocumentList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Tender = () => (
  <TableStructure
    title="Tenders"
    heading={false}
    list={TenderDocumentList}
    columnNo={1}
    leftMenuList={MarketLeftNavsList}
    longMenuList={true}
  />
);

export default Tender;
